import { Main } from './components';

const ThreePlExcelReports = () => <Main />;

export default ThreePlExcelReports;
